import { z } from "zod";
import "../../assets/css/adminPages/faq/style.scss";
import PageLoader from "../../components/pageLoader/index";
import UseFAQs from "../../hooks/public/useFAQs";
import FaqAddModal from "./FaqAddModal";
import FaqUpdateCard from "./FaqUpdateCard";

const QUESTION_MAX_LENGTH = 150;
const ANSWER_MAX_LENGTH = 500;

const schema = z.object({
  questionEn: z
    .string()
    .trim()
    .min(1, { message: "Required" })
    .max(QUESTION_MAX_LENGTH, `Max length is ${QUESTION_MAX_LENGTH}`),

  answerEn: z
    .string()
    .trim()
    .min(1, { message: "Required" })
    .max(ANSWER_MAX_LENGTH, `Max length is ${ANSWER_MAX_LENGTH}`),
});

const Index = () => {
  const { data, isLoading, error, create, update, remove } = UseFAQs();

  if (error) return null;
  return (
    <div className="faq-update-section">
      <div className="custom-container">
        <div className="content-section">
          <h1 className="page-title">FAQ</h1>
          <div className="content-body">
            <div className="row">
              <div className="col-12">
                <FaqAddModal schema={schema} onCreate={create} />
              </div>
              <div className="col-12">{isLoading && <PageLoader />}</div>
              {data.map((item) => (
                <div key={item.id} className="col-xl-6">
                  <FaqUpdateCard
                    schema={schema}
                    faq={item}
                    onUpdate={update}
                    onDelete={remove}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
